import { render, staticRenderFns } from "./NoFeedback.vue?vue&type=template&id=f04b023e&scoped=true"
import script from "./NoFeedback.vue?vue&type=script&lang=ts"
export * from "./NoFeedback.vue?vue&type=script&lang=ts"
import style0 from "./NoFeedback.vue?vue&type=style&index=0&id=f04b023e&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f04b023e",
  null
  
)

export default component.exports